// extracted by mini-css-extract-plugin
export default {"container":"RetailerGuard_container__OqWbu","notFound":"RetailerGuard_notFound__QS5iI"};